import React from 'react';
import { CheckIcon, CloseIcon } from '@icons';
import Button from '@primitives/Button';
import cx from 'classnames';
import CircularLoader from '@navi/web-ui/lib/icons/CircularLoaderIcon';

type UploadLoadingComponent = {
  name: string;
  onCancel: () => void;
  containerClassName?: string;
  isInProgress?: boolean;
};

function UploadLoadingComponent({
  name,
  onCancel,
  containerClassName,
  isInProgress
}: UploadLoadingComponent) {
  return (
    <div
      className={cx(
        'flex items-center justify-between text-gray-600 p-1.5 mt-3.5 rounded-lg border border-solid border-green-500 bg-[var(--upload-component-border)] h-[40px] ml-3 gap-2',
        containerClassName
      )}
    >
      <div className="flex gap-2">
        <div>
          {isInProgress ? (
            <CircularLoader width={20} height={20} />
          ) : (
            <CheckIcon width={20} height={20} color="var(--green-base)" fill="var(--green-base)" />
          )}
        </div>
        <div className="max-w-[200px] text-ellipsis overflow-hidden whitespace-nowrap">{name}</div>
      </div>
      <Button variant="text" onClick={onCancel}>
        <CloseIcon />
      </Button>
    </div>
  );
}

export default UploadLoadingComponent;
